import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const modules = require.context("../modules", true, /\/reducers\/moduleReducer\.js$/);

const dynamicReducers = modules.keys().reduce((reducers, modulePath) => {
  const moduleName = modulePath.split("/")[1]; 
  const moduleReducer = modules(modulePath).default; 
  reducers[moduleName] = moduleReducer(); 
  return reducers;
}, {});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["survey"], 
};

const rootReducer = persistReducer(persistConfig, combineReducers(dynamicReducers));

export default rootReducer;
